/**
 * V288: 모달 오버레이 공통 컴포넌트.
 *
 * mousedown + mouseup(click)이 모두 오버레이 자체에서 발생한 경우에만 onClose 호출.
 * 모달 내부에서 드래그하여 오버레이로 마우스가 나가도 닫히지 않음.
 *
 * 사용법:
 *   <ModalOverlay onClose={handleClose} style={overlayStyle}>
 *     <div style={modalStyle}>...</div>
 *   </ModalOverlay>
 *
 * 또는 backdrop 전용 (형제 구조):
 *   <ModalOverlay onClose={handleClose} style={backdropStyle} />
 */
import React from 'react';
import { useModalOverlayClose } from '../hooks/useModalOverlayClose';

interface ModalOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose?: () => void;
}

export function ModalOverlay({ onClose, children, ...rest }: ModalOverlayProps) {
  const overlayProps = useModalOverlayClose(onClose);
  return (
    <div {...rest} {...overlayProps}>
      {children}
    </div>
  );
}
